import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './fonts.css';
import './index.css';
import './startups.css';
import './marketing-pages.css';
import './product-mockups.css';
import './revamp.css';
import './experience.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
